import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Typography } from "@circle-react-uikit/Typography";
import { IconButton } from "../../uikit/HeaderV3/IconButton";
import { BlockPreviewList } from "../BlockList/BlockPreviewList";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import { useCategorizedElementsList } from "./useCategorizedElementsList";

export const ElementsList = () => {
  const blocks = useBuilderStore(state => state.blockMapping);
  const closeSidebarView = useBuilderStore(state => state.closeSidebarView);

  const categorizedBlocks = useCategorizedElementsList({
    blocks,
  });

  return (
    <div className="divide-primary flex h-full w-[20.5rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <SidebarHeaderTitle>
            {t("builder_ui.elements_list.add_elements")}
          </SidebarHeaderTitle>
          <IconButton
            name="24-close"
            iconSize={24}
            ariaLabel={t("close")}
            onClick={closeSidebarView}
          />
        </div>
      </SidebarHeader>
      <div className="flex h-full w-full flex-col overflow-hidden">
        <OverlayScrollbarsComponent>
          {categorizedBlocks.map(category => (
            <div
              key={category.category}
              className="flex flex-col gap-2 px-5 py-3"
            >
              <Typography.LabelXs color="text-tertiary" weight="semibold">
                {category.category}
              </Typography.LabelXs>
              <BlockPreviewList isElementType blocks={category.blocks} />
            </div>
          ))}
        </OverlayScrollbarsComponent>
      </div>
    </div>
  );
};
